import { MutableState } from 'src/replicant/State';

/**
 * Set current region id in state.
 * @param state
 * @param regionId
 */
export function setCurrentRegion(state: MutableState, regionId: string): void {
  state.match2.regions.currentRegion = regionId;
}
